import React from "react";
import { useSelector } from "react-redux";
import { FormikField } from "@qgiv/core-donor";
import { constants } from "@qgiv/core-js";
import { selectTeams } from "../../../../../../redux/slices/teamsSlice";
import { selectAllP2pSettings } from "../../../../../../redux/slices/p2pSettingsSlice";
import { selectCmsControlByType } from "../../../../../../redux/slices/cmsSettingsSlice";

const ConnectedTeamNameInput = () => {
    const {
        ENUMS: {
            CMS_Control: { P2P_REGISTRATION_CONTENT },
        },
    } = constants;
    const teams = useSelector(selectTeams);
    const savedTeams = teams.filter((team) => team.id !== "new-team");
    const teamNames = savedTeams.map((team) => {
        const { title = "" } = team;
        const teamName = `${title}`;
        return teamName.toLowerCase();
    });
    const { enableUniqueTeamName } = useSelector(selectAllP2pSettings);
    const control = useSelector((state) =>
        selectCmsControlByType(P2P_REGISTRATION_CONTENT, state),
    );
    const {
        options: {
            createTeamModal: { teamNameLabel = "Team Name" },
        },
    } = control;

    const validate = (value) => {
        let error = "";
        // Validate on empty or space only values
        if (value.trim().length === 0) {
            error += `${teamNameLabel} is required.`;
        }
        const trimmedTeamName = value.trim();
        const lowercaseTeamName = trimmedTeamName.toLowerCase();
        // Validate for unique team name
        if (enableUniqueTeamName && teamNames.includes(lowercaseTeamName)) {
            error += `${teamNameLabel} must be unique.`;
        }

        return error || undefined;
    };
    const teamNameInputProps = {
        id: "New-Team-Name",
        name: "New_Team_Name",
        label: teamNameLabel,
        type: "text",
        validate,
    };
    return <FormikField {...teamNameInputProps} />;
};

export default ConnectedTeamNameInput;
